import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=318ef95f&scoped=true"
import script from "./AlertCard.vue?vue&type=script&lang=js"
export * from "./AlertCard.vue?vue&type=script&lang=js"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=318ef95f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ef95f",
  null
  
)

export default component.exports